import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  verifyUserEmail
} from '../actions/user-session'

import Loading from '../components/common/loading'

import { SuccessIcon } from '../components/icons'

class Verify extends Component {
  componentWillMount() {
    const { verificationCode } = this.props.match.params
    const { userSession } = this.props

    if (verificationCode && !userSession.verification) this.props.verifyUserEmail(verificationCode)
  }

  render() {
    const { userSession } = this.props

    return (
      <div className="verify">
        <div>

        </div>
        {
          userSession && userSession.verification
          ? <div>
              <SuccessIcon />
              <h1>Your account is all set up</h1>
              <Link to="/login">Log in →</Link>
            </div>
          : userSession.error
            ? <div>
                <h1>{userSession.error.message}</h1>
              </div>
            : <div>
                <h1>We are verifying your account</h1>
                <Loading />
              </div>
        }
      </div>
    )
  }
}

Verify.propTypes = {
  userSession: PropTypes.object,
  verifyUserEmail: PropTypes.func
}

Verify.defaultProps = {
  userSession: {},
  verifyUserEmail: function() {}
}

export const mapStateToProps = (state) => {
  return {
    userSession: state.userSession
  }
}

export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    verifyUserEmail
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Verify)



// WEBPACK FOOTER //
// ./src/containers/verify.js